module.exports = __webpack_public_path__ + "media/images/athletes/1364-482ec268651fc6cd6d36e083620a3266.png";